import { Modal, Checkbox } from "antd";
import styled from "styled-components";
import designSystemColors from "../../../../../styles";

export const AntModal = styled(Modal).attrs({
  className: "custom-modal",
})`
  .ant-modal-content {
    border-radius: 16px;
  }
  .ant-modal-body {
    padding: 24px;
  }
`;

export const StyledCheckbox = styled(Checkbox)`
  .ant-checkbox-inner {
    border-color: ${designSystemColors.generalButtons};
  }
  .ant-checkbox-checked .ant-checkbox-inner {
    background-color: ${designSystemColors.generalButtons};
    border-color: ${designSystemColors.generalButtons};
  }

  .ant-checkbox-wrapper:hover .ant-checkbox-inner,
  .ant-checkbox:hover .ant-checkbox-inner,
  .ant-checkbox-input:focus + .ant-checkbox-inner {
    border-color: ${designSystemColors.generalButtons};
  }
`;

export const LoadingWrapper = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 1rem;
`;

export const LoadingText = styled.span`
  font-family: "Roboto", sans-serif;
  font-weight: bold;
  font-size: 14px;
`;

export const ModalTitle = styled.span`
  font-family: "Roboto", sans-serif;
  font-weight: bold;
  font-size: 18px;
`;

export const SectionTitle = styled.p`
  font-size: 14px;
  font-weight: bold;
  color: ${designSystemColors.gray700};
  margin-bottom: 12px;
`;

export const Description = styled.p`
  font-size: 14px;
  font-weight: bold;
  color: ${designSystemColors.grayChart};
  margin-bottom: 20px;
`;

export const SalesListContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  background-color: ${designSystemColors.backgrounds.lightGray};
  border: 1px solid ${designSystemColors.border.lightGray};
  border-radius: 12px;
  padding: 16px;
`;

export const SaleCard = styled.div<{ isSelected?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px;
  border: 2px solid
    ${(props) =>
      props.isSelected
        ? designSystemColors.generalButtons
        : designSystemColors.border.input};
  border-radius: 8px;
  background-color: ${designSystemColors.backgrounds.lightGray};
  cursor: pointer;
  transition: all 0.2s;
`;

export const SaleInfo = styled.div`
  display: flex;
  flex-direction: column;
  margin-left: 12px;
  flex: 1;
`;

export const SalesNameInfo = styled.span`
  font-weight: bold;
  font-size: 14px;
  color: ${designSystemColors.gray700};
`;

export const SalesDetailInfo = styled.span`
  font-size: 12px;
  color: ${designSystemColors.grayChart};
`;

export const SaleValue = styled.span`
  font-weight: bold;
  font-size: 14px;
  color: ${designSystemColors.gray700};
`;

export const EmptyState = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 32px;
  color: ${designSystemColors.border.lightGray};
  font-size: 13px;

  svg {
    font-size: 40px;
    margin-bottom: 8px;
  }
`;
export const EmptyStateText = styled.p``;

export const EmptyData = styled.div`
  width: 100%;
  height: 300px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 1rem;
`;

export const EmptyDataText = styled.span`
  font-size: 20px;
  font-weight: 500;
  font-family: "Ubuntu";
`;
